<template>
  <section class="section" id="totem-journeys-section">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <totem-journeys-title
        :journeysQty="journeysQty"
        @update-dates="updateDates"
        @update-store="updateStore"
        @get-journeys="updateJourneys"
      />

      <b-pagination
        v-show="journeysQty > perPage"
        :current.sync="current"
        :total="journeysQty"
        :per-page="perPage"
        order="is-centered"
        aria-next-label="Próxima página"
        aria-previous-label="Página anterior"
        aria-page-label="Página"
        aria-current-label="Página atual"
        @change="changePage"
      ></b-pagination>

      <h2
        v-if="journeysQty === 0"
        class="subtitle has-text-centered is-spaced"
        style="margin-top: 5rem"
      >
        {{ $t("totemJourneys.noJourneys") }}
      </h2>

      <totem-journeys-table
        v-else
        :journeys="journeys"
        @get-journey-details="getJourneyDetails"
      />
      <br />

      <b-pagination
        v-show="journeysQty > perPage"
        :current.sync="current"
        :total="journeysQty"
        :per-page="perPage"
        order="is-centered"
        aria-next-label="Próxima página"
        aria-previous-label="Página anterior"
        aria-page-label="Página"
        aria-current-label="Página atual"
        @change="changePage"
      ></b-pagination>

      <b-modal :active.sync="isJourneyDetailsModalActive" :width="1100">
        <totem-journey-details-modal :journey="journey" :events="events" />
      </b-modal>
    </div>
  </section>
</template>

<script>
import { common } from "../../mixins/common";
import totemJourneysTitle from "./TotemJourneysTitle";
import totemJourneysTable from "./TotemJourneysTable";
import totemJourneyDetailsModal from "./TotemJourneyDetailsModal";

export default {
  mixins: [common],

  components: {
    totemJourneysTitle,
    totemJourneysTable,
    totemJourneyDetailsModal
  },

  data() {
    return {
      isLoading: false,
      dates: [],
      storeId: "",
      journeys: [],
      journeysQty: 0,
      current: 1,
      perPage: 50,
      journey: {},
      events: [],
      isJourneyDetailsModalActive: false
    };
  },

  methods: {
    getJourneys(skip) {
      this.isLoading = true;
      this.$store
        .dispatch("getTotemJourneys", {
          beginDate: this.dates[0],
          endDate: this.dates[1],
          storeId: this.storeId || undefined,
          skip,
          limit: this.perPage
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.journeys = res.data.payload.journeys;
            this.journeysQty = res.data.payload.journeysQty;
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    updateJourneys() {
      this.current = 1;
      this.getJourneys(0);
    },

    changePage(p) {
      this.getJourneys((p - 1) * this.perPage);
    },

    updateDates(dates) {
      this.dates = [
        this.moment(dates ? dates[0] : undefined).format("YYYY-MM-DD"),
        this.moment(dates ? dates[1] : undefined).format("YYYY-MM-DD")
      ];

      if (dates) this.updateJourneys();
    },

    updateStore(storeId) {
      if (storeId === this.storeId) return;

      this.storeId = storeId;
      this.updateJourneys();
    },

    getJourneyDetails(journey) {
      this.isLoading = true;
      this.$store
        .dispatch("getTotemJourneyEvents", journey.journeyId)
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.journey = journey;
            this.events = res.data.payload.events;
            this.isJourneyDetailsModalActive = true;
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  mounted() {
    this.updateDates();
    this.updateJourneys();
  }
};
</script>

<style scoped>
#totem-journeys-section {
  margin-top: 3rem;
  min-height: 94vh;
  background-color: hsl(0, 0%, 96%);
}
</style>
